<template>
    <div class="main-section main-section--pick" v-if="loading">
        <div class="main-section-head main-section-head--center">
            <h3 class="title">부분인테리어 <b>PICK</b></h3>
        </div>
        <div class="main-section-body">
            <div class="main-pick">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in category.children" :key="index">
                            <!-- <router-link :to="`/portfolio/partial?_category=${category._id}?second=${item._id}`" class="pick-list"> -->
                            <router-link :to="`/portfolio/partial?_category=${item._id}`" class="pick-list">
                                <span class="pick-list__thumb">
                                    <span class="pick-list__thumbnail">
                                        <span class="pick-list__thumbnail-image" :style="backImage(index + 1)"></span>
                                    </span>
                                    <span class="pick-list__thumb-image"></span>
                                </span>
                                <span class="pick-list__title">{{item.name}}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="main-pick__pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props : {
        category_id : {type : String, default : ""}
    },
    data : () => {
        return {
            loading : false,

            category : null
        }
    },
    created() {
    },
    mounted() {
        this.init();
    },
    methods : {
        backImage(index) {
            return {
                'backgroundImage' : `url('/images/main/main-pick${index}.png')`
            }
        },
        settingSwiper() {
            // 부분인테리어 PICK
            this.$nextTick( () => {
                var slide = new Swiper ('.main-pick .swiper-container', {
                    allowTouchMove: true,
                    spaceBetween : 40,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: true,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 8,
                    slidesPerGroup: 1,
                    speed: 300,
                    loop: true,
                    pagination: {
                        el: '.main-pick__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-pick__next',
                        prevEl: '.main-pick__prev'
                    },
                    breakpoints: {
                        500: {
                            slidesPerView: 3,
                            spaceBetween : 15,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween : 15,
                        },
                        1400: {
                            spaceBetween : 25,
                        }
                    }
                });
            });
        },
        async init() {
            try {
                var { category } = await api.v1.portfolios.categories.getCategory({ _id: this.category_id });
                this.category = category;

                this.loading = true;
                this.settingSwiper();

            }catch(error) {
                console.error(error);
            }
        },
    }
}
</script>
